<template>
  <div style="padding:0;position:relative;">
		<input style="width:100%;padding:0.3rem;" readonly="true" :value="inputValue" @click="isActive = true" @keydown.esc="isActive = false">
		<dig-calendar @OnPickDate="OnPickDate" ref=calendar :style="{'z-index':1, maxWidth : '300px', width:'100%', 'background-color': 'white', position : 'absolute', display : isActive ? 'block' : 'none'}">
		</dig-calendar>
	</div>
</template>

<script>
import Calendar from './calendar.vue'
import moment from 'moment'

export default {
  	props: {
		value:String
	},
	data() {
		return {
			isActive : false,
		};
	},
	components: {
		'dig-calendar':Calendar
	},
	methods: {
		OnPickDate(d) {
			this.isActive = false;
			this.$emit('input', d.formatted);
		},
	},
	computed: {
		inputValue: function() {
			if (!this.value) { return ''; }
			return moment(this.value).format('DD MMM YYYY');
		}
	}
}
</script>
